import React from "react";
import { observer } from "mobx-react-lite";
import OrderDTO from "@/dto/order/OrderDTO";
import { useGlobalStore } from "@/store/hooks";
import OrderStatus from "@/enum/OrderStatus";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import { shouldShowDropShippingDetail } from "@/utils/ShopUtils";
import DropShippingSubmitButton from "../dropShipping/components/DropShippingSubmitButton";
import OrderOperationMenu from "../../OrderOperationMenu";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";

interface OperationColumnProps {
    order: OrderDTO;

    tab: OrderTab;

    isSupplierShop?: boolean;

    isQianniu?: boolean;
}

const OperationColumn: React.FC<OperationColumnProps> = function (props) {
    const { order, tab, isSupplierShop, isQianniu } = props;

    const { storage } = useOrderManagementStore();

    const globalStore = useGlobalStore();

    const info = order?.retailerDropShippingInfo;
    const shop = globalStore.shopMapping.get(order.shopId);

    const shopType = shop?.type;

    // 是否为等待发货状态
    const isPendingShipment = order.status === OrderStatus.PENDING_SHIPMENT;

    const isPendingSubmitDropShippingOrder = !info || (info && info.orderStatus === OrderStatus.CANCELED);

    const isShowDropshippingSubmitOrder =
        isPendingSubmitDropShippingOrder &&
        isPendingShipment &&
        globalStore.companyRoleStore.isRetailer &&
        ![OrderTab.SHIPPED_REFUNDING, OrderTab.PENDING_SHIPMENT_REFUNDING].includes(tab) &&
        shouldShowDropShippingDetail(shop) &&
        !order.preShipped;

    return (
        <td>
            {isShowDropshippingSubmitOrder && <DropShippingSubmitButton order={order} />}

            <p className="mb5">
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();

                        storage.toggleShowOrderDetail(order.id);
                    }}
                >
                    详情
                </a>
            </p>

            {/* 供货商的未付款订单列表需要屏蔽操作 */}
            {!(isSupplierShop && tab === OrderTab.PENDING_PAYMENT) ? (
                <OrderOperationMenu
                    isSupplierShop={isSupplierShop}
                    order={order}
                    tab={tab}
                    isQianniu={isQianniu}
                    shopType={shopType}
                />
            ) : null}
        </td>
    );
};

export default observer(OperationColumn);
